import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function useCaseGeneralSettingsSchema() {
  const { t } = useTranslation();
  return Yup.object().shape({
    name: Yup.string().required(t("label.isRequiredValidation", { field: t("label.name") })),
    description: Yup.string(),
  });
}
